export default __webpack_public_path__ + "static/media/weapon1.61b2ea8e.png";